import React, { useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import NewsletterCell from '../../components/newsletterCell';
import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';
import { getNewsletters } from '../../httpcalls/contractThunk';
import D_NewsletterCell from './d_newslettercell';
import { MetaTagHandler } from '../../../library/client/serverCallHandler';
import Footer from '../../components/footer';



const Demo = (props) => {
    const dispatch = useDispatch();
    const accounts = useSelector((state) => state.authManagement.accounts)
    const newsletter = useSelector((state) => state.mainapp.newsSlice.newsletter)

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>


            <MetaTagHandler>
                {() => (
                    <>
                        <title>Try Demo | PLURI</title>
                        <meta name="description" content="Store your content on the blockchain. Try the demo now." />
                        <meta property="og:title" content="PLURI | Try Demo" />
                        <meta property="og:description" content="Store your content on the blockchain. Try the demo now." />
                        <meta property="og:image" content={`https://${process.env.REACT_APP_ORIGIN}/assets/pluriBanner.png`} />
                        <meta property="og:url" content={`https://${process.env.REACT_APP_ORIGIN}/demo`} />
                        <meta property="og:site_name" content="PLURI" />
                        <meta property="og:type" content="website" />
                        <meta property="og:locale" content="en_US" />
                    </>
                )}
            </MetaTagHandler>

            <div className='vivify fadeIn duration-300 delay-200'>
                <D_NewsletterCell />

                <Outlet />

                <div className='bolt-notice-block'>
                    <div className='bolt-notice'>
                        <i className='material-icons'>bolt</i>
                        <div className='bolt-text'>
                            <h3>Stored On The Blockchain</h3>
                            <h2>With <a href='/'>Pluri</a></h2>
                        </div>
                    </div>
                    <button className='bolt-button'>
                        <i className='material-icons-outlined'>help_outline</i>
                        <span>What Does This Mean?</span>
                    </button>
                </div>
            </div>

            <Footer />

            <style dangerouslySetInnerHTML={{
                __html: `
                :root {
                    --main-color: #E88B2F
                }

                .bolt-notice-block {


                    left: 50%;
                    transform: translate(-50%, -50%);
                    z-index: 150;
                }

                .bolt-button {
                    display: none;
                }

                .bolt-notice {
                    background-color: rgb(18 29 33);
                    padding: 10px;

                }
            
            `}}>

            </style>

        </>
    );
};

export default Demo;
